module.exports = __webpack_public_path__ + "static/media/turning.12bd411c.svg";